import { useEffect, useRef, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { useDispatch } from "react-redux";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall } from "../CommonComponents/CustomHooks";
import { AutoCompleteBoxNew, FormButton } from "../CommonComponents/InputBox";

const UploadCandidateFile = () => {
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        event: '',
        client: ''
    });
    const inputrefs = useRef([]);
    const fileTypes = 'pdf'
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [responseData, setResponseData] = useState([])
    const fileSizeDynamic = '500'
    const totalNumberFileDynamic = '100'

    const handleClear = () => {
        setFormData({
            event: '',
            client: ''
        })
        setSelectedFiles([])
        setResponseData([])
    }

    const handleFileUploader = async (files) => {
        const newFiles = Array.from(files);
        if (selectedFiles.length + newFiles.length > Number(totalNumberFileDynamic)) {
            alert(`You can only upload a maximum of ${totalNumberFileDynamic} files.`);
            return;
        }
        for (let file of newFiles) {
            const extArr = file.name.split('.');
            const fileExtension = extArr[extArr.length - 1].toLowerCase();
            if (!fileTypes.split(',').includes(fileExtension)) {
                alert('Invalid file type. Please select pdf files.');
                return;
            }
            await processFile(file, fileExtension);
        }
    };

    const processFile = async (file, fileExtension) => {
        const extArr = file.name.split('.');
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = async () => {
                try {
                    const img = reader.result;
                    const base64Image = img.split(',')[1];
                    const newFileData = {
                        Base64File: base64Image,
                        FileExt: fileExtension,
                        FileSize: (file.size / 1024).toFixed(2),
                        FileName: extArr.slice(0, -1).join('.'),
                    };
                    const isUploaded = selectedFiles.some(item => item.Base64File === base64Image);
                    if (isUploaded) {
                        console.error(`${newFileData.FileName} file already exists. Please upload a different file.`);
                    } else {
                        setSelectedFiles(prevFiles => {
                            const updatedFiles = [...prevFiles, newFileData];
                            if (updatedFiles.length > Number(totalNumberFileDynamic)) {
                                updatedFiles.splice(0, updatedFiles.length - Number(totalNumberFileDynamic));
                            }
                            return updatedFiles;
                        });
                    }
                    resolve();
                } catch (error) {
                    console.error("Processing error:", error);
                    reject(error);
                }
            };
            reader.onerror = (error) => {
                console.error("File reading error:", error);
                reject(error);
            };
            reader.readAsDataURL(file);
        });
    };

    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    const handleUploadCandidate = async () => {
        if (formData.client === '') {
            await NotificationSound('ERROR', 'please enter Client.', 'txtClientCode', inputrefs);
            return
        }
        if (formData.event === '') {
            await NotificationSound('ERROR', 'please enter Event.', 'txtEventCode', inputrefs);
            return
        }
        if (selectedFiles.length <= 0) {
            await NotificationSound('ERROR', 'please choose at least one file.');
            return
        }
        try {
            await dispatch(setSubLoading(true));
            setResponseData([]);
            for (let i = 0; i < selectedFiles.length; i++) {
                let currentFile = { ...selectedFiles[i] };
                let fileSizeKB = Number(currentFile.FileSize);
                if (fileSizeKB > Number(fileSizeDynamic)) {
                    const tempRes = { index: i, status: 'error', message: `File size exceeds ${fileSizeDynamic} KB.` };
                    setResponseData((prev) => [...prev, tempRes]);
                    continue;
                }
                let res = await ApiCall('/api/Master/UploadCandidateFile', {
                    UploadCandidateFiles: [currentFile],
                    ...formData
                });
                const tempRes = { index: i, status: res.status, message: res.message };
                if (res.status === 'EXPIRED') {
                    NotificationSound(res.status, res.message)
                    break;
                }
                setResponseData((prev) => [...prev, tempRes]);
                await delay(1000);
            }
        } catch (error) {
            NotificationSound('ERROR', 'Failed to upload the files. Please try again.');
        } finally {
            await dispatch(setSubLoading(false));
        }
    };

    const handleDelete = (base64Image) => {
        const fileIndex = selectedFiles.findIndex(file => file.Base64File === base64Image);

        if (fileIndex === -1) return;
        setSelectedFiles(prevFiles => prevFiles.filter(file => file.Base64File !== base64Image));
        setResponseData(prevResponse => prevResponse.filter((_, index) => index !== fileIndex));
    };

    const truncateFileName = (fileName, maxLength = 100) => {
        if (fileName.length > maxLength) {
            return fileName.substring(0, maxLength) + '...';
        }
        return fileName;
    };

    useEffect(() => {
        document.title = 'Candidate File Upload';
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <h6 className="m-0">  {'Candidate File Upload'} </h6>
                    </div>
                    <div className='card-body pb-1'>
                        <div className="row">
                            <div className='col-md-6'>
                                <AutoCompleteBoxNew
                                    id="txtClientCode"
                                    divclassname='col-md-6 mb-1'
                                    label='Client Code'
                                    required={true}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtEventCode'].focus()
                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    maxLength='10'
                                    placeholder='Client Code'
                                    name='ClientCode'
                                    value={formData.client || ''}
                                    onChange={(e) => setFormData({ ...formData, client: e.target.value })}
                                    autocompleteType='GetClientData'
                                />
                                <AutoCompleteBoxNew
                                    id="txtEventCode"
                                    divclassname='col-md-6 mb-1'
                                    required={true}
                                    label='Event Code'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['btnSub'].focus()
                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    maxLength='210'
                                    placeholder='Event Code'
                                    name='EventCode'
                                    value={formData.event || ''}
                                    autocompleteType='GetEventData'
                                    contextKey={formData.client}
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || ''
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, event: newInputValue })
                                        }
                                    }}
                                />

                                <div className=' col-lg-4 h-25'>
                                    <label className="form-label">{("Choose Files")} <span className='ms-1 mb-2' style={{ color: 'red' }}>*</span></label>
                                    <FileUploader
                                        className="col-lg-12 col-md-12 col-sm-12"
                                        multiple
                                        types={fileTypes.split(",")}
                                        handleChange={(files) => handleFileUploader(files)}
                                    />
                                </div>
                            </div>

                            <div className='col-md-6'>
                                <b className='ps-3 text-primary-emphasis fs-6'>{("Note")} : </b>
                                <ol className='pt-3'>
                                    <li className='NotesPoint' >{("Please upload file(s) only with extension pdf.")}</li>
                                    <li className='NotesPoint' >{(`Maximum ${totalNumberFileDynamic} File allowed.`)}</li>
                                    <li className='NotesPoint' >{(`File Size should be upto ${fileSizeDynamic} KB.`)}</li>
                                </ol>
                            </div>
                            <div className="col-3 mt-3">
                                <FormButton
                                    id={'btnSub'}
                                    inputrefs={inputrefs}
                                    handleSubmit={handleUploadCandidate}
                                    Export={false}
                                    handleClear={handleClear}
                                />

                            </div>
                            <div className='mt-7 ms-3'>
                                {selectedFiles.length > 0 && (
                                    <div className='col-md-8 col-lg-8 w-100 mt-3'>
                                        <div className='recoard-bata'>
                                            <div className="table-responsive">
                                                <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                                    <thead style={{ backgroundColor: "#EEEEF2", color: "black" }}>
                                                        <tr className='light-bg'>
                                                            <th>{("Sr No.")}</th>
                                                            <th>{("File Name")}</th>
                                                            <th>{("File Size (KB)")}</th>
                                                            <th style={{ textAlign: "center" }}>{("Status")}</th>
                                                            <th style={{ textAlign: "center" }}>{("Action")}</th>
                                                            {responseData?.length > 0 && <th style={{ textAlign: "center" }}>{("Message")}</th>}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {selectedFiles.map((item, index) => (
                                                            <tr key={index}>
                                                                <td style={{ width: '15%' }}>{index + 1}</td>
                                                                <td >
                                                                    <div>{(truncateFileName(`${item.FileName}.${item.FileExt}`))}</div>
                                                                </td>
                                                                <td>{`${item.FileSize} KB`}</td>
                                                                <td className={`text-center ${responseData[index]?.status?.toLowerCase() === 'error'?.toLowerCase() && "text-danger"} ${responseData[index]?.status?.toLowerCase() === 'success'?.toLowerCase() && "text-success"}`} style={{ width: '20%', textWrap: "nowrap" }}>
                                                                    {(responseData?.length && responseData[index]?.status?.toUpperCase() === ""
                                                                        ? "Ready To Upload"
                                                                        : responseData[index]?.status?.toUpperCase() || "Ready To Upload")}
                                                                </td>
                                                                <td className="text-center" style={{ width: '7%' }}>
                                                                    <i className="fa-regular fa-trash-can text-danger arrow" onClick={() => handleDelete(item.Base64File)}> </i>
                                                                </td>
                                                                {responseData?.length > 0 && <td className={`text-center ${responseData[index]?.status?.toLowerCase() === 'error'?.toLowerCase() && "text-danger"} ${responseData[index]?.status?.toLowerCase() === 'success'?.toLowerCase() && "text-success"}`} style={{ width: '20%', textWrap: "nowrap" }}>
                                                                    {(responseData[index]?.message)}
                                                                </td>}
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default UploadCandidateFile;